import { useContext } from 'react';

import { CompanyContext } from '../CompanyContext';

const useCompanyData = () => useContext(CompanyContext);
export default useCompanyData;
